import React, { useState } from 'react';
import {
    Route as ReactRouterRoute,
    Routes as ReactRouterRoutes,
} from 'react-router-dom';
import { Route } from '../../../../types';
import { DPage } from '../../../dum';
import { SUpsertOrderQuotationDialog } from '../../../smart';
import { OrderQuotationsPage } from './order-quotations/order-quotations-page';
import { DFab } from '../../../dum/simple/button/d-fab';

const productsPages: Route[] = [
    {
        name: 'OrderQuotationsPage',
        path: '/',
        component: <OrderQuotationsPage />,
        title: 'Cotizaciones',
        navbar: false,
    },
];

export function OrderQuotationsHomePage() {
    const [orderQuotationUpsertDialog, setOrderQuotationUpsertDialog] =
        useState(false);

    return (
        <DPage>
            <DFab
                onClick={() => {
                    setOrderQuotationUpsertDialog(true);
                }}
            />
            <ReactRouterRoutes>
                {productsPages.map((page, index) => {
                    return (
                        <ReactRouterRoute
                            path={page.path}
                            element={page.component}
                            key={index}
                        />
                    );
                })}
            </ReactRouterRoutes>
            <SUpsertOrderQuotationDialog
                open={orderQuotationUpsertDialog}
                setOpen={setOrderQuotationUpsertDialog}
            />
        </DPage>
    );
}
